import React from "react";

const IconPerson: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.2452 2.71157C9.67513 2.0902 8.87884 1.74802 7.99993 1.74802C7.11634 1.74802 6.31741 2.08813 5.74993 2.70566C5.1763 3.32999 4.89681 4.1785 4.96243 5.09474C5.09251 6.90237 6.45511 8.37285 7.99993 8.37285C9.54476 8.37285 10.905 6.90267 11.0371 5.09533C11.1036 4.18737 10.8224 3.34064 10.2452 2.71157Z"
        fill="#d14f64"
      />
      <path
        d="M13.1562 14.997H2.84371C2.70873 14.9988 2.57505 14.9702 2.45241 14.9132C2.32977 14.8563 2.22124 14.7725 2.13473 14.6679C1.9443 14.4381 1.86754 14.1243 1.92438 13.8069C2.17164 12.4222 2.94332 11.259 4.15621 10.4425C5.23375 9.71757 6.59869 9.3186 7.99996 9.3186C9.40123 9.3186 10.7662 9.71787 11.8437 10.4425C13.0566 11.2587 13.8283 12.4219 14.0755 13.8066C14.1324 14.124 14.0556 14.4378 13.8652 14.6676C13.7787 14.7722 13.6702 14.8561 13.5475 14.9131C13.4249 14.9701 13.2912 14.9988 13.1562 14.997Z"
        fill="#d14f64"
      />
    </svg>
  );
};

export default IconPerson;
